import React from "react";
import RedButton from "../../common-components/RedButton";

const MealsStructure = ({ text, isReload, isExport, onClickExportBtn }) => {
  return (
    <div
      className="flexStart"
      style={{
        marginTop: text === "Diet type" ? "20px" : "0",
        columnGap: "1rem",
      }}
    >
      <h2 className="page-heading">{text || ""}</h2>
      {isReload && (
        <button
          variant="dark"
          type="button"
          onClick={isReload}
          style={{
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            border: "none",
            backgroundColor: "#000",
            cursor: "pointer",
            color: "#fff",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-arrow-clockwise"
            viewBox="0 0 16 16"
            style={{
              color: "#fff",
              fill: "#fff",
            }}
          >
            <path
              fillRule="evenodd"
              d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
            />
            <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
          </svg>
        </button>
      )}
      {isExport && (
        <RedButton btnName="Export Data" onClickBtn={onClickExportBtn} />
      )}
    </div>
  );
};

export default MealsStructure;